import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ISignatureConfigService } from '../../../interfaces/isignatureproviderservice';

export interface IDocusignUserAccount {
  account_id: string;
  account_name: string;
  base_uri: string;
  default: boolean;
  is_default: boolean;
}

export interface IDocusignBrand {
  brandId: string;
  brandLanguages: string[];
  brandName: string;
  defaultBrandLanguage: string;
  isOverridingCompanyName: boolean;
  isSendingDefault: boolean;
  isSigningDefault: boolean;
}

interface IDocusignTemplateRecipient {
  recipientId: string;
  recipientType: string;
  roleName: string;
  routingOrder: string;
}

export interface IDocusignTemplate {
  templateId: string;
  name: string;
  recipients: {
    recipientCount: string;
    carbonCopies: IDocusignTemplateRecipient[];
    signers: IDocusignTemplateRecipient[];
    editors: IDocusignTemplateRecipient[];
  };
  documents: any[];
}

@Injectable({
  providedIn: 'root',
})
export class DocusignConfigService implements ISignatureConfigService {
  constructor(private http: HttpClient) {}

  public getUserAccounts(): Observable<IDocusignUserAccount[]> {
    const url = `${environment.kpHost}/adv2/config/providers/docusign/user-accounts`;
    return this.http.get<IDocusignUserAccount[]>(url).pipe(
      catchError((error) => {
        console.error('Error getting user accounts', error);
        return of(null);
      })
    );
  }

  public getUserBrands(accountId: string): Observable<IDocusignBrand[]> {
    const url = `${environment.kpHost}/adv2/config/providers/docusign/user-brands?accountId=${accountId}`;
    return this.http.get<IDocusignBrand[]>(url).pipe(
      catchError((error) => {
        console.error('Error getting user brands', error);
        return of([]);
      })
    );
  }

  public getUserTemplates(accountId: string): Observable<IDocusignTemplate[]> {
    const url = `${environment.kpHost}/adv2/config/providers/docusign/user-templates?accountId=${accountId}`;
    return this.http.get<IDocusignTemplate[]>(url).pipe(
      map((templates) =>
        templates
          // Filter out templates with no name, and return only specific fields
          .filter((t) => !!t.name)
          .map((template) => ({
            templateId: template.templateId,
            name: template.name,
            recipients: template.recipients,
            documents: template.documents,
          }))
      ),
      catchError((error) => {
        console.error('Error getting user templates', error);
        return of([]);
      })
    );
  }
}
